import type { Message } from '@dia/db';

/**
 * The help sheet's pure parts: whether a row that goes to the hosts is open,
 * and how many host replies the guest has not seen yet.
 */

export type HelpRowState = 'open' | 'sign_in' | 'closed';

/**
 * Safety and the 911 row never ask this: they work with no login and no
 * signal. The rows that reach the hosts need a stay session inside the window.
 */
export function hostRowState(signedIn: boolean, personalOpen: boolean): HelpRowState {
  if (!signedIn) return 'sign_in';
  return personalOpen ? 'open' : 'closed';
}

/**
 * Host replies newer than the last time the guest opened Messages. A guest who
 * has never opened it counts every host message, so a welcome note shows.
 * A guest's own messages never count, and neither do system notes.
 */
export function unreadCount(
  messages: Array<Pick<Message, 'author_kind' | 'created_at'>>,
  seenAt: string | null,
): number {
  const seen = seenAt ? Date.parse(seenAt) : Number.NEGATIVE_INFINITY;
  const floor = Number.isNaN(seen) ? Number.NEGATIVE_INFINITY : seen;
  return messages.filter((m) => m.author_kind === 'staff' && Date.parse(m.created_at) > floor).length;
}

/** The query string that opens the Requests form as a problem report. */
export const PROBLEM_QUERY = 'tipo=problema';

export function isProblemReport(search: string): boolean {
  return new URLSearchParams(search).get('tipo') === 'problema';
}
